export default "__VITE_ASSET__f5084033__"